// extracted by mini-css-extract-plugin
export default {"popover-root":"_9KIBf","popoverRoot":"_9KIBf"};